import { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { Colors } from '../../themes/colors';

export type MessageThreadHeaderProps = {
  /**
   * Rendered inside the header area. Pass any content — title text, status
   * pills, back buttons, menus, etc. The host remains responsible for
   * Issue-specific affordances (severity, assignee) so this slot stays
   * intentionally unstructured.
   */
  children: ReactNode;
};

/**
 * MessageThreadHeader
 *
 * A thin layout wrapper that positions the thread header above the message
 * list. All content is supplied by the consumer via `children`, keeping
 * Issue-specific affordances (severity dropdown, assignee chip, etc.) out of
 * this shared primitive.
 */
export const MessageThreadHeader = (props: MessageThreadHeaderProps) => {
  return <View style={styles.container}>{props.children}</View>;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.role.canvas,
    zIndex: 1,
  },
});
